import { jsxs as e, jsx as l } from "react/jsx-runtime";
function d(C) {
  return /* @__PURE__ */ e(
    "svg",
    {
      width: "146",
      height: "43",
      viewBox: "0 0 146 43",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...C,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M64.5063 13.8643L60.0798 20.2934L55.6268 13.8643H52.0961L58.2617 22.5067L51.7799 31.5707H55.3106L60.0798 24.7463L64.7962 31.5707H68.3269L61.8451 22.5067L68.0107 13.8643H64.5063Z",
            fill: "#446CB3"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M77.8916 16.183C79.1826 16.183 80.1839 16.6046 80.869 17.4214C81.5277 18.2118 81.8966 19.3712 81.9229 20.8467H73.3596C73.5176 19.4239 73.9919 18.2909 74.7297 17.4741C75.5202 16.6046 76.5741 16.183 77.8916 16.183ZM77.9179 13.5481C75.5465 13.5481 73.623 14.3913 72.2266 16.0776C70.8301 17.7376 70.1187 20.0299 70.1187 22.8492C70.1187 25.6685 70.8828 27.8818 72.3847 29.4628C73.8865 31.0437 75.9944 31.8605 78.603 31.8605C79.7887 31.8605 80.7899 31.7815 81.6331 31.597C82.4762 31.4126 83.3721 31.1228 84.2943 30.7275L84.4261 30.6748V27.8555L84.1099 27.9872C82.3182 28.7514 80.5001 29.1466 78.682 29.1466C76.9957 29.1466 75.6519 28.646 74.7297 27.6447C73.8338 26.6698 73.3332 25.247 73.2542 23.4026H85.1638V21.5318C85.1638 19.1604 84.5051 17.2106 83.214 15.7614C81.9229 14.2859 80.1312 13.5481 77.9179 13.5481Z",
            fill: "#446CB3"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M97.5741 13.5481C96.3621 13.5481 95.2291 13.7852 94.2542 14.2595C93.3847 14.6811 92.6469 15.2608 92.1199 15.9985L91.7247 13.8379H89.1952V31.5443H92.2516V22.2696C92.2516 20.0826 92.6469 18.5017 93.4637 17.5795C94.2542 16.6573 95.5453 16.183 97.2579 16.183C98.549 16.183 99.4976 16.4992 100.104 17.1579C100.71 17.8166 100.999 18.8179 100.999 20.1616V31.5443H104.056V20.0563C104.056 17.7903 103.503 16.1303 102.422 15.0763C101.342 14.0751 99.7084 13.5481 97.5741 13.5481Z",
            fill: "#446CB3"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M115.755 29.2256C114.253 29.2256 113.146 28.6986 112.382 27.6446C111.618 26.5643 111.223 24.9307 111.223 22.7965C111.223 20.6886 111.618 19.0286 112.408 17.8692C113.173 16.7362 114.279 16.1829 115.755 16.1829C117.467 16.1829 118.706 16.6835 119.47 17.6584C120.26 18.6597 120.656 20.3724 120.656 22.7438V23.2971C120.656 25.405 120.26 26.9332 119.496 27.8554C118.706 28.7776 117.467 29.2256 115.755 29.2256ZM120.603 13.8642L120.656 15.0763L120.735 15.8667C119.47 14.3121 117.678 13.5217 115.412 13.5217C113.094 13.5217 111.275 14.3385 109.984 15.9721C108.693 17.5794 108.035 19.8454 108.035 22.7438C108.035 25.6158 108.693 27.8818 109.958 29.4627C111.249 31.0436 113.094 31.8604 115.412 31.8604C117.757 31.8604 119.575 31.0436 120.814 29.41L121.13 31.5443H123.686V6.61829H120.629L120.603 13.8642Z",
            fill: "#446CB3"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M130.326 7.43518C129.825 7.43518 129.403 7.59327 129.061 7.90946C128.718 8.22564 128.56 8.72627 128.56 9.38499C128.56 10.0437 128.718 10.518 129.061 10.8605C129.403 11.2031 129.825 11.3612 130.326 11.3612C130.8 11.3612 131.222 11.2031 131.564 10.8605C131.907 10.518 132.091 10.0437 132.091 9.38499C132.091 8.72627 131.907 8.25199 131.564 7.90946C131.222 7.59327 130.8 7.43518 130.326 7.43518Z",
            fill: "#446CB3"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M128.771 31.5707H131.854V13.8643H128.771V31.5707Z",
            fill: "#446CB3"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M145.055 28.9621C144.818 29.0412 144.475 29.0939 144.053 29.1729C143.632 29.2256 143.21 29.2783 142.736 29.2783C141.946 29.2783 141.313 29.0412 140.865 28.5142C140.417 28.0136 140.18 27.2495 140.18 26.2746V16.3411H145.186V13.8643H140.18V9.85925H138.283L137.15 13.6008L134.647 14.7074V16.3411H137.124V26.38C137.124 30.0161 138.889 31.8869 142.367 31.8869C142.815 31.8869 143.316 31.8342 143.895 31.7551C144.475 31.6497 144.897 31.5443 145.213 31.3862L145.344 31.3335V28.8831L145.055 28.9621Z",
            fill: "#446CB3"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M24.172 0.400024H12.4204L0.299988 21.4L12.4204 42.4L14.8182 38.2633L5.09547 21.4L14.8182 4.56313H21.7743L24.172 0.400024Z",
            fill: "#446CB3"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M15.8985 14.6547L18.2699 10.5443L14.8182 4.56311L12.4204 8.67353L15.8985 14.6547Z",
            fill: "#D24D57"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M29.4945 4.56311L31.8922 8.69987L14.8182 38.2632L12.4204 34.1265L29.4945 4.56311Z",
            fill: "#D24D57"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M20.167 42.4L22.5384 38.2633H29.4945L39.2172 21.4L29.4945 4.56313L31.8922 0.400024L44.0127 21.4L31.8922 42.4H20.167Z",
            fill: "#446CB3"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M28.3615 28.0663L25.9637 32.2031L29.4945 38.2633L31.8922 34.1529L28.3615 28.0663Z",
            fill: "#D24D57"
          }
        )
      ]
    }
  );
}
export {
  d as XenditLogoIcon
};
